import { Component, h, Prop, Host } from "@stencil/core";
import { ButtonVariant } from "@trumpf/ux.ui/dist/types/components";

@Component({
    tag: "ux-w-shopping-lists-item",
    styleUrl: "shopping-lists-item.scss",
    shadow: false
})
export class ShoppingListsItem {
    /** Title of the service call */
    @Prop() headline: string = "";
    /** Total amount of items in a list  */
    @Prop() amount: number = 0;
    /** 'Article' label  */
    @Prop() articleLabel: string = "";
    /** show details link */
    @Prop() listLink: string = "";
    /** title attribute for the detail link */
    @Prop() listLinkTitle: string = "";
    /** show details link */
    @Prop() addListToCartLink: string = "";
    /** title attribute for the detail link */
    @Prop() addListToCartLinkTitle: string = "";
    /** Label for last change */
    @Prop() lastChangeLabel: string = "";
    /** formatted date of last change */
    @Prop() lastChange: string = "";

    render() {
        const baseClass = "ux-w-shopping-lists-item";
        const {
            headline,
            listLink,
            listLinkTitle,
            addListToCartLink,
            addListToCartLinkTitle,
            lastChangeLabel,
            lastChange,
            amount,
            articleLabel
        } = this;

        return (
            <Host class={baseClass}>
                <div class={`${baseClass}__header`}>
                    <div
                        class={`${baseClass}__headline ux-text-title ux-text-title--bold`}
                        title={headline}
                        data-testid="list-title"
                    >
                        {headline}
                    </div>
                    <div class="ux-text-tiny">
                        <span data-testid="amount">{amount}</span>{" "}
                        {articleLabel}
                    </div>
                    {lastChange && (
                        <div class="ux-text-tiny">
                            {lastChangeLabel}
                            <strong data-testid="last-change">
                                &nbsp;
                                {lastChange}
                            </strong>
                        </div>
                    )}
                </div>
                <div class={`${baseClass}__cta-container`}>
                    <ux-button
                        class={`${baseClass}__button`}
                        href={listLink}
                        title={listLinkTitle}
                        data-testid="details-link"
                    >
                        {listLinkTitle}
                    </ux-button>
                    <div
                        class={{
                            [`${baseClass}__add-to-cart-container`]: true,
                            [`${baseClass}__add-to-cart-container--disabled`]:
                                amount === 0
                        }}
                    >
                        <ux-button
                            class={{
                                [`${baseClass}__button--disabled`]: amount === 0
                            }}
                            variant={"primary" as ButtonVariant}
                            disabled={amount === 0}
                            href={amount === 0 ? null : addListToCartLink}
                            title={addListToCartLinkTitle}
                            data-testid="add-to-cart"
                        >
                            {addListToCartLinkTitle}
                        </ux-button>
                    </div>
                </div>
            </Host>
        );
    }
}
